// Pristine docs: https://pristine.js.org/
import Pristine from 'pristinejs';

export default (el) => {
  const ui = {
    el,
    formFields: Array.from(el.querySelectorAll('.input')),
    submitPath: el.getAttribute('action')
  };

  const state = {
    formErrors: [],
    initialErrors: [],
    isValid: true
  };

  const validationDefaults = {
    // parent element where the error/success class is added
    classTo: 'form__item',
    errorClass: 'has--error',
    successClass: 'has--success',
    // element where error text element is appended
    errorTextParent: 'form__item',
    // type of element to create for the error text
    errorTextTag: 'span',
    // class of the error text element
    errorTextClass: 'form__error'
  };

  let formIntId; // this can be anything and not this stupid

  let fetchOpts = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    }
  };

  // activate validation
  const pristine = new Pristine(ui.el, validationDefaults);

  // validation method
  const isValid = () => pristine.validate();

  // return list of errors/dirty inputs & cache them
  const getFormErrors = () => {
    const formErrors = pristine.getErrors();
    const errArray = formErrors.map((e) => e.input);
    state.formErrors = errArray;

    return formErrors;
  };

  const formIsDirty = () => {
    return Array.isArray(state.formErrors) && state.formErrors.length > 0;
  };

  const scrollToError = (cb = () => {}) => {
    getFormErrors();

    if (formIsDirty()) {
      state.formErrors[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      if (typeof cb !== 'undefined') {
        // waiting to fire so scroll can do its thing
        setTimeout(() => {
          cb.call();
        }, 250);
      }
    }
  };

  const focusErrorInput = () => {
    getFormErrors();

    if (formIsDirty()) {
      state.formErrors[0].focus();
    }
  };

  const setAriaValidation = (arr = state.formErrors, formState) => {
    getFormErrors();

    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach((err) => {
        err.setAttribute('aria-invalid', formState);
      });
    }
  };

  const clearPolling = () => {
    window.clearInterval(formIntId);
  };

  const pollFormState = () => {
    formIntId = window.setInterval(() => {
      getFormErrors();

      // find inputs newly validated...
      const diffArray = state.initialErrors.filter(
        (e) => !state.formErrors.includes(e)
      );

      // ...if there are any, reset them
      if (diffArray.length > 0) {
        setAriaValidation(diffArray, false);
      }

      // if no errors remain, reset & kill interval
      if (state.formErrors.length < 1) {
        setAriaValidation(ui.formFields, false);
        clearPolling();
      }
    }, 2500);
  };

  const setFormState = () => {
    state.isValid = isValid();
    getFormErrors();

    // cache original set of errors one time to test against
    state.initialErrors = state.formErrors;

    if (state.formErrors.length > 0) {
      setAriaValidation(state.formErrors, true);
      scrollToError(focusErrorInput);
      pollFormState();
    }
  };

  ui.el.addEventListener('submit', (ev) => {
    ev.preventDefault();

    // this only needs to be called once per submission
    setFormState();

    // don't try to post form if there's nowhere to post it
    if (!ui.submitPath || ui.submitPath === '') {
      // eslint-disable-next-line no-console
      console.warn('This form requires a valid value for its action attribute.');
      return;
    }

    // get all form values & handle radios
    const formBody = Array.from(
      ev.target.querySelectorAll('input, textarea, select')
    ).reduce((acc, cur) => {
      if (cur.getAttribute('type') === 'radio' && cur.checked) {
        acc[cur.getAttribute('id')] = 'true';
      } else {
        acc[cur.getAttribute('name')] = cur.value;
      }

      return acc;
    }, {});

    fetchOpts = Object.assign(fetchOpts, {
      body: JSON.stringify(formBody)
    });

    window.fetch(ui.submitPath, fetchOpts)
      .then((res) => res.json())
      .then((res) => {
        // eslint-disable-next-line operator-linebreak
        const message =
          `<div class="flex flex--justify-center">
            <h4 class="heading heading--h5">${JSON.stringify(res.message)}</h4>
          </div>`;

        ui.el.innerHTML = message;
      });
  });
};
